import { useContext, useEffect, useRef } from "react";
import { Grid } from "@mui/material";
import { ParagraphText } from "../../../../Libraries";
import "./../variantAStyle.css";
import { Box } from "@mui/material";
import styles from "./../styles.module.css";
import { HeaderRupin } from "../../../common";
import FooterRupin from "../../../common/FooterRupin";
import { LanguageContext } from "../../../../context/LanguageContext";
import { RECAPTCHA_SITE_KEY } from "../../../../constants";
import ReCAPTCHA from "react-google-recaptcha";

const Recapcha = ({ setReCaptcha, isResetReCaptcha }) => {
  const [I18n] = useContext(LanguageContext);
  const recaptchaRef = useRef(null);

  const handleReset = (e) => {
    if (recaptchaRef.current) {
      recaptchaRef.current.reset();
      setReCaptcha("")
    }
  };

  useEffect(() => {
    if (isResetReCaptcha)
      handleReset()
  }, [isResetReCaptcha])

  return (
    <Box className={styles.ReCAPTCHA}>
      <ReCAPTCHA
        ref={recaptchaRef}
        sitekey={RECAPTCHA_SITE_KEY}
        onChange={(e) => setReCaptcha(e)}
        badge='inline'
      />
    </Box>
  );
}

export default Recapcha;